import styled from 'styled-components';

export const LogoWrapper = styled.div`
display: flex;
.headerFirstLogo{
    display: flex;
    align-items: center;
    &:after{

        flex-grow: 0.1;
        content: '|';
        font-size: 40px;
        font-weight: 100;
        display: flex;
        gap: 30;
        color: #707070;
        justify-content: flex-end;
        align-items: center;

}
img{
   /* max-width:130px;
    max-height: 70px;*/
    padding:15px 16px 0 30px;
}
}
.headerSecondLogo{
    margin-left: 20px;

    img{
        max-width:115px;
        padding: 10px 0 0 0;
      /*  height: 50px;*/
    }
}


`;